// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3lAuQ","selects":"Documents_selects__1BnNB"};